import React from 'react'
import {
  Checkbox, DateField, NumericSelectField, TextField, validateFieldsEx,
} from '../../../../shared/fields'
import { ApplicationModel } from '../../../../models/ApplicationModel'
import EMDGAccordion from '../../../../shared/EMDGAccordion'
import { getDateAsString, Salutation } from '../../../../shared/Utility'

export interface Props {
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    preview?: boolean
}

export interface State {
}

export default class Declaration extends React.Component<Props, State> {
  applicationDeclarationAccepted: Checkbox
  declarantTitle: NumericSelectField
  declarantGivenName: TextField
  declarantFamilyName: TextField
  declarantPosition: TextField
  declarationDate: DateField
  declarationAppCompleteAccepted: Checkbox

  constructor(props: Props) {
    super(props)

    this.state = {}
  }

  componentDidUpdate(prevProps: Props) {
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    validateFieldsEx(
      focus,
      callback,
      this.applicationDeclarationAccepted,
      this.declarantTitle,
      this.declarantGivenName,
      this.declarantFamilyName,
      this.declarantPosition,
      this.declarationDate,
      this.declarationAppCompleteAccepted,
    )
  }

  render() {
    const { model, onChange, preview } = this.props
    model.declarationDate = getDateAsString(new Date())

    const salutationDataSource = [
      { value: Salutation.Mr, label: 'Mr' },
      { value: Salutation.Mrs, label: 'Mrs' },
      { value: Salutation.Ms, label: 'Ms' },
      { value: Salutation.Miss, label: 'Miss' },
      { value: Salutation.Other, label: 'Other' },
    ]

    return (
      <div className="form-item">
        { preview && <h4>Declaration by an authorised person</h4>}
        <EMDGAccordion expanded header="Declaration by an authorised person">
          <div className="form-content-preview" style={{ fontSize: this.props.preview ? '10pt' : 'inherits' }}>
            <div>
              I declare that:
              <ul>
                <li style={{ marginTop: '0px' }}>
                  the proposed activities outlined in this application and any associated expenditure has been endorsed
                  {' '}
                  by the applicant’s board/management committee or person with authority to commit the applicant to these activities
                </li>
                <li style={{ marginTop: '0px' }}>the applicant will comply with, and require that its subcontractors and independent contractors comply with, all applicable laws</li>
                <li style={{ marginTop: '0px' }}>
                  the information contained in this application together with any statement provided is accurate and complete
                  {' '}
                  and I understand that the giving of false or misleading information is a serious offence under the
                  {' '}
                  <i>Criminal Code Act 1995 (Cth)</i>
                </li>
                <li style={{ marginTop: '0px' }}>the business or organisation that I am applying on behalf of does not currently have any outstanding debt with Austrade</li>
                <li style={{ marginTop: '0px' }}>I am not applying for a grant to pay for business-as-usual activities</li>
                <li style={{ marginTop: '0px' }}>I have not conducted business in an unprofessional or unethical manner </li>
                <li style={{ marginTop: '0px' }}>I am not currently under insolvency administration</li>
                <li style={{ marginTop: '0px' }}>I do not have any outstanding disqualifying convictions</li>
                <li style={{ marginTop: '0px' }}>I have complied with all my obligations under taxation laws during the current income year and the previous 2 income years</li>
                <li style={{ marginTop: '0px' }}>
                  I am not included on the National Redress Scheme’s list of
                  {' '}
                  <i>Institutions that have not joined or signified their intent to join the Scheme</i>
                </li>
                <li style={{ marginTop: '0px' }}>
                  I am authorised to submit this form on behalf of the applicant and acknowledge that this is the equivalent of signing this application.
                </li>
              </ul>
            </div>
            <br />
            <div>
              I acknowledge that:
              <ul>
                <li style={{ marginTop: '0px' }}>all documents that may be relevant to this application will be made available (at the applicant’s expense) to Austrade upon request</li>
                <li style={{ marginTop: '0px' }}>
                  if Austrade is satisfied that any statement made in an application
                  {' '}
                  is incorrect, incomplete, false or misleading Austrade may, at its absolute discretion, take appropriate action.
                  {' '}
                  I note such action may include excluding an application from further consideration; withdrawing an offer of funding;
                  {' '}
                  using the information contained in the application for a fraud investigation, and terminating a grant agreement
                  {' '}
                  between the Commonwealth and the grantee including recovering funds already paid
                </li>
                <li style={{ marginTop: '0px' }}>the information in this application is communicated to Austrade in electronic form</li>
                <li style={{ marginTop: '0px' }}>only the applicant’s primary contact can enter into an agreement with the Commonwealth on behalf of the applicant</li>
                <li style={{ marginTop: '0px' }}>any outstanding debt that my business or organisation holds with Austrade would render the application as ineligible for EMDG funding.</li>
              </ul>
            </div>
            <br />
            <div>
              I (the applicant) understand and accept that:
              <ul>
                <li style={{ marginTop: '0px' }}>I must enter into a legally binding grant agreement with the Commonwealth before grant funding can be provided</li>
                <li style={{ marginTop: '0px' }}>during and at the conclusion of the grant period, Austrade may request evidence to confirm grant funds have been spent on grant activities</li>
                <li style={{ marginTop: '0px' }}>I may be asked to participate in the periodic evaluation of the services undertaken by Austrade</li>
                <li style={{ marginTop: '0px' }}>I may be contacted by Austrade to participate in case studies.</li>
                <li style={{ marginTop: '0px' }}>I will acknowledge the EMDG grant on my business website.</li>
                <li style={{ marginTop: '0px' }}>
                  as a registered Australian business with an ABN, I can use the Australia Nation Brand logo alongside my own branding on signage,
                  {' '}
                  publications and promotional activities when promoting my business’ (or SME members’) eligible products.
                  {' '}
                  Any use of the Australia’s Nation Brand logo must be done in accordance with the Australia’s Nation Brand Guidelines,
                  {' '}
                  including all requirements in relation to sizing, colouring, alignment and placement.
                </li>
              </ul>
            </div>
          </div>

          <div className="form-item">
            <Checkbox
              ref={(r) => { this.applicationDeclarationAccepted = r }}
              id="applicationDeclarationAccepted"
              required
              requiredMessage="This field is required"
              onChange={(val) => onChange({ applicationDeclarationAccepted: val || null })}
              value={model.applicationDeclarationAccepted}
              label="By marking this box, I agree to all of the above declarations and confirm all of the above statements to be true."
              preview={preview}
            />
            <NumericSelectField
              ref={(r) => { this.declarantTitle = r }}
              id="declarantTitle"
              label="Title"
              value={model.declarantTitle}
              onChange={(declarantTitle) => onChange({ declarantTitle })}
              dataSource={salutationDataSource}
              block={false}
              required
              preview={preview}
            />

            <TextField
              ref={(r) => { this.declarantGivenName = r }}
              id="declarantGivenName"
              label="Given name"
              value={model.declarantGivenName}
              onChange={(val) => onChange({ declarantGivenName: val?.trim() })}
              required
              maxLength={50}
              preview={preview}
            />

            <TextField
              ref={(r) => { this.declarantFamilyName = r }}
              id="declarantFamilyName"
              label="Family name"
              value={model.declarantFamilyName}
              onChange={(val) => onChange({ declarantFamilyName: val?.trim() })}
              required
              maxLength={50}
              preview={preview}
            />

            <TextField
              ref={(r) => { this.declarantPosition = r }}
              id="declarantPosition"
              label="Position title"
              value={model.declarantPosition}
              onChange={(declarantPosition) => onChange({ declarantPosition })}
              required
              maxLength={50}
              preview={preview}
            />

            <DateField
              ref={(r) => { this.declarationDate = r }}
              id="declarationDate"
              label="Date"
              value={model.declarationDate}
              onChange={(declarationDate) => onChange({ declarationDate })}
              required
              disabled
              preview={preview}
            />

            <div className="form-item mt-4">
              <Checkbox
                ref={(r) => { this.declarationAppCompleteAccepted = r }}
                id="declarationAppCompleteAccepted"
                required
                requiredMessage="This field is required"
                onChange={(val) => onChange({ declarationAppCompleteAccepted: val || null })}
                value={model.declarationAppCompleteAccepted}
                label={'I acknowledge, Austrade does not accept incomplete applications. '
                + 'I have reviewed the application form for completeness and verified that I have provided all mandatory evidence and supporting documentation prior to submitting the application. '
                + 'I understand that I will not be able to provide information at a later stage and if my application is incomplete, it will be deemed ineligible.'}
                preview={preview}
              />
            </div>
          </div>
        </EMDGAccordion>
      </div>
    )
  }
}
